import { MONTHS, QUARTERS } from "constant/variables";
import React from "react";
import { Label, Input } from "reactstrap";

const QuarterMonthsDropdown = ({
  value,
  onChange,
  label = "Quarter/Month",
  className = "",
}) => {
  return (
    <div className={`col-md-12 col-sm-12 ${className}`}>
      <Label>{label}</Label>
      <Input
        type="select"
        name="select"
        className="form-control digits uiStyleDashboard"
        value={value}
        onChange={onChange}
      >
        {[...QUARTERS, ...MONTHS].map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    </div>
  );
};

export default QuarterMonthsDropdown;
